import React, { useState } from 'react';

// Components
import Button from '../CustomButton';

// Styles
import styles from './style.module.scss';

type ButtonGroupOption = {
  label: string;
  value: any;
};

interface ButtonGroupProps {
  options: ButtonGroupOption[];
  onRenderOptionContent?: (option: ButtonGroupOption) => React.ReactNode;
  className?: string;
  value: any;
  onChange: (value: any) => void;
  classes?: {
    root?: string;
    button?: string;
  }
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ options, onRenderOptionContent, className, value, onChange, classes }) => {
  const [selected, setSelected] = useState<any | null>(value);

  const handleClick = (value: any) => {
    setSelected(value);
    onChange?.(value);
  }

  return (
    <div className={`${styles.root} ${classes?.root}`}>
      {options.map((option) => {
        return (
          <Button
            classes={{
              root: `${styles.button} ${classes?.button} ${selected === option.value ? styles.selected : ''}`
            }}
            onClick={() => handleClick(option.value)}
            variant='secondary'
            key={option.value}
          >
            {onRenderOptionContent ? onRenderOptionContent(option) : option.label}
          </Button>
        )
      })}
    </div>
  )
};

export default ButtonGroup;
